module.exports = __webpack_public_path__ + "static/media/lvlComplete.7494d39d.png";